// extracted by mini-css-extract-plugin
export default {"input":"EditableTableNumberCell_input__AQUQj"};